import Wip from "./components/wip/Wip"


function App() {
  return (
    <>
    <div id='main' className='bg-[#EAEDE5] min-h-screen w-full flex flex-col'>
      <Wip />
    </div>
    </>
  )
}

export default App
